export class ParametrosConsultarAsignacion {
  idServidor: number;
  direccionIp: string;
  idUrl: number;
  idSede: number;
  idPlataforma: number;
  idRol: number;
  idVlan: number;
  nombreUsuario: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/parametros-consultar-asignacion.ts